/**
 * Organizasyon read model (GET /team/organization, v0.1.150): the contract's shape, re-exported so the screen imports
 * from one place, plus the Turkish words the page uses.
 */

import type { OrgMemberState } from '@twin/contracts';

export type { OrganizationView, OrgDepartment, OrgMember, OrgMemberState } from '@twin/contracts';

export const ORG_STATE_LABELS: Readonly<Record<OrgMemberState, string>> = Object.freeze({
  working: 'çalışıyor',
  ready: 'hazır',
  paused: 'duraklatıldı',
  planned: 'kurulacak',
  human: 'insan',
});

export const ORG_RUNTIME_LABELS: Readonly<Record<string, string>> = Object.freeze({
  claude: 'Abonelik ajanı',
  genesis: 'Genesis ajanı',
  vertex: 'Vertex ajanı',
  code: 'kod',
});
